export const UserModule = {
    namespaced: true,
    state: {
        accessToken: "",
        _id: null,
        userInfo: {},
    }
}